/* MD Cabecera: publica el alto de la cabecera fija para que el menú se pegue justo debajo */
(function () {
  'use strict';

  var ROOT = '.md-cabecera';
  var CSS_VAR = '--md-cabecera-height';

  var instances = new WeakMap();

  function initSection(container) {
    if (container.dataset.mdInit) return;
    container.dataset.mdInit = 'true';

    /* El menú (sección aparte) lee esta variable en su `top` sticky; vale 0 si la cabecera no se fija */
    function update() {
      var sticky = container.classList.contains('md-cabecera--sticky');
      var height = sticky ? container.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty(CSS_VAR, Math.round(height) + 'px');
    }

    update();

    var observer = null;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(update);
      observer.observe(container);
    } else {
      window.addEventListener('resize', update);
    }

    /* Un logo que carga después puede cambiar el alto */
    var logo = container.querySelector('.md-cabecera__logo-img');
    if (logo && !logo.complete) {
      logo.addEventListener('load', update);
    }

    /* Limpieza al descargar la sección en el editor */
    function destroy() {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', update);
      if (logo) logo.removeEventListener('load', update);
      document.documentElement.style.setProperty(CSS_VAR, '0px');
      instances.delete(container);
    }

    instances.set(container, { destroy: destroy });
  }

  var sections = document.querySelectorAll(ROOT);
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(ROOT);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(ROOT);
    var api = section && instances.get(section);
    if (api) api.destroy();
  });
})();
